import React from "react";
// import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Routes, Route } from "react-router-dom";
import Login from "./Pages/LoginPage";
import Dashboard from "./Pages/DashboardPage";
import Complaint from "./Pages/ComplaintPage";
import User from "./Pages/UserPage";
import Authorize from "./Pages/AuthorizePage";
import DL from "./Layout/DashboardLayout";
import './Dashboard';
import ProtectedRoute from './Components/Authorize/ProtectedRoute';
import NotFoundPage from './Pages/NotFoundPage';
import CaseOriginPage from "./Pages/Masters/CaseOriginPage";
import CallTypePage from "./Pages/Masters/CallTypePage";
import CaseCategoryPage from "./Pages/Masters/CaseCategoryPage";
import SR_TypePage from "./Pages/Masters/SR_TypePage";
import SR_SubTypePage from "./Pages/Masters/SR_SubTypePage";
import CaseLocationPage from "./Pages/Masters/CaseLocationPage";
import CaseStagePage from "./Pages/Masters/CaseStagePage";
import './Dashboard.css';
import './Complaint.css';
import '../node_modules/react-datepicker/dist/react-datepicker.css';
import CountryPage from "./Pages/Masters/CountryPage";
import MenuPage from "./Pages/Masters/MenuPage";

import PatientVisit from "./Pages/PatientVisitPage";
import Transaction from "./Pages/TransactionPage";

import InvoicePage from "./Pages/Reports/InvoiceReportPage";
import SOAPage from "./Pages/Reports/SOAReportPage";

import PartnerPage from "./Pages/PartnerPage";
import PartnerUserPage from "./Pages/PartnerUserPage";

import DocumentPage from "./Pages/DocumentPage";
import PartnerCasePage from "./Pages/PartnerCasePage";
import Graph from "./Components/Dashboard/Graph";
import RateCardPage from "./Pages/RateCardPage";
import DocumentUploadPage from "./Pages/DocumentUploadPage";
import NotificationPage from "./Pages/NotificationPage";

import MhlSales from "./Pages/MHLSalesPage";
import B2bRegistrationPage from "./Pages/B2bRegistrationPage";
import NPSQuestionnairePage from "./Pages/NPSQuestionnairePage";
import APSCMetlinkReportPage from "./Pages/APSCMetlinkReportPage";
import ARCMetlinkReportPage from "./Pages/ARCMetlinkReportPage";
import MetlinkUploaderPage from "./Pages/MetlinkUploaderPage";
import MetlinkLeadSupportPage from "./Pages/MetlinkLeadSupportPage";
import useDisableCopyAndDevTools from "./Utils/disableCopyAndDevTools";

import TRFRegistrationListPage from "./Pages/TRFRegistrationListPage";
import ElmahErrorsPage from "./Pages/ElmahErrorsPage";
import SalesAdmin_PartnerListPage from "./Pages/SalesAdmin_PartnerListPage";

import RegistrationTrackingReportPage from "./Pages/RegistrationTrackingReportPage";
import PartnerLoginTrackingReportPage from "./Pages/PartnerLoginTrackingReportPage";
import PartnerActivityReportPage from "./Pages/PartnerActivityReportPage";
import RegistrationStatusPage from "./Pages/RegistrationStatusPage";
import OrganizationMasterPage from "./Pages/OrgLocMappingMasterPage";
import RoleUserAccessMappingPage from "./Pages/RoleUserAccessMappingPage";
import OrgLocMappingMasterPage from "./Pages/OrgLocMappingMasterPage";
import NPSFeedbackReportPage from "./Pages/NPSFeedbackReportPage";
import SalesAdminLoginTrackingReportPage from "./Pages/SalesAdminLoginTrackingReportPage";
import TourProvider from "./Providers/Tour Provider/TourProvider";


const App = () => {

  useDisableCopyAndDevTools()

  return (
    <>
    {/* // <Router> */}
    <TourProvider tourName="dashboard"/>
    <TourProvider tourName="registration"/>
    <Routes>
      <Route path="/insights/:encodedData" element={<MhlSales />} />
      <Route path="/" element={<Login />} />
      <Route path="/login" element={<Login />} />
      <Route path="/dashboard" element={<DL><Dashboard /></DL>} />
      <Route path="/graph" element={<DL><Graph /></DL>} />
      <Route path="/elmah_errors" element={<DL />}>
        <Route index element={<ElmahErrorsPage />} />
      </Route>
      <Route path="/registration" element={<DL />}>
        <Route index element={<B2bRegistrationPage />} />
      </Route>
      <Route path="/registrationlist" element={<DL />}>
        <Route index element={<ProtectedRoute><TRFRegistrationListPage /></ProtectedRoute>} />
      </Route>
      <Route path="/dashboard" element={<DL />}>
        <Route index element={<Dashboard />} />
      </Route>
      <Route path="/nps" element={<DL />}>
        <Route index element={<ProtectedRoute><NPSQuestionnairePage /></ProtectedRoute>} />
      </Route>
      <Route path="/metlink_upload_report" element={<DL />}>
        <Route index element={<ProtectedRoute><MetlinkUploaderPage /></ProtectedRoute>} />
      </Route>
      <Route path="/metlink_report_apsc" element={<DL />}>
        <Route index element={<ProtectedRoute><APSCMetlinkReportPage /></ProtectedRoute>} />
      </Route>
      <Route path="/metlink_report_arc" element={<DL />}>
        <Route index element={<ProtectedRoute><ARCMetlinkReportPage /></ProtectedRoute>} />
      </Route>
      <Route path="/metlink_lead_support" element={<DL />}>
        <Route index element={<ProtectedRoute><MetlinkLeadSupportPage /></ProtectedRoute>} />
      </Route>
      <Route path="/complaint" element={<DL />}>
        <Route index element={<ProtectedRoute><Complaint /></ProtectedRoute>} />
      </Route>
      <Route path="/user" element={<DL />}>
        <Route index element={<ProtectedRoute><User /></ProtectedRoute>} />
      </Route>
      <Route path="/patientvisit" element={<DL />}>
        <Route index element={<ProtectedRoute><PatientVisit /></ProtectedRoute>} />
      </Route>
      <Route path="/transactions" element={<DL />}>
        <Route index element={<ProtectedRoute><Transaction /></ProtectedRoute>} />
      </Route>
      <Route path="/authorize" element={<Authorize />} />
      <Route path="*" element={<NotFoundPage />} />
      <Route path="/caseorigin" element={<DL />}>
        <Route index element={<ProtectedRoute><CaseOriginPage /></ProtectedRoute>} />
      </Route>
      <Route path="/calltype" element={<DL />}>
        <Route index element={<ProtectedRoute><CallTypePage /></ProtectedRoute>} />
      </Route>
      <Route path="/casecategory" element={<DL />}>
        <Route index element={<ProtectedRoute><CaseCategoryPage /></ProtectedRoute>} />
      </Route>
      <Route path="/case_srtype" element={<DL />}>
        <Route index element={<ProtectedRoute><SR_TypePage /></ProtectedRoute>} />
      </Route>
      <Route path="/case_srsubtype" element={<DL />}>
        <Route index element={<ProtectedRoute><SR_SubTypePage /></ProtectedRoute>} />
      </Route>
      <Route path="/caselocation" element={<DL />}>
        <Route index element={<ProtectedRoute><CaseLocationPage /></ProtectedRoute>} />
      </Route>
      <Route path="/casestage" element={<DL />}>
        <Route index element={<ProtectedRoute><CaseStagePage /></ProtectedRoute>} />
      </Route>
      <Route path="/country" element={<DL />}>
        <Route index element={<ProtectedRoute><CountryPage /></ProtectedRoute>} />
      </Route>
      <Route path="/menumaster" element={<DL />}>
        <Route index element={<ProtectedRoute><MenuPage /></ProtectedRoute>} />
      </Route>


      <Route path="/soa" element={<DL />}>
        <Route index element={<ProtectedRoute><SOAPage /></ProtectedRoute>} />
      </Route>
      <Route path="/invoices" element={<DL />}>
        <Route index element={<ProtectedRoute><InvoicePage /></ProtectedRoute>} />
      </Route>

      <Route path="/partnerlist" element={<DL />}>
        <Route index element={<ProtectedRoute><PartnerPage /></ProtectedRoute>} />
      </Route>
      <Route path="/partneruser" element={<DL />}>
        <Route index element={<ProtectedRoute><PartnerUserPage /></ProtectedRoute>} />
      </Route>

      <Route path="/documents" element={<DL />}>
        <Route index element={<ProtectedRoute><DocumentPage /></ProtectedRoute>} />
      </Route>
      <Route path="/partnercase" element={<DL />}>
        <Route index element={<ProtectedRoute><PartnerCasePage /></ProtectedRoute>} />
      </Route>
      <Route path="/ratecard" element={<DL />}>
        <Route index element={<ProtectedRoute><RateCardPage /></ProtectedRoute>} />
      </Route>

      <Route path="/document_upload" element={<DL />}>
        <Route index element={<ProtectedRoute><DocumentUploadPage /></ProtectedRoute>} />
      </Route>

      <Route path="/notifications" element={<DL />}>
        <Route index element={<ProtectedRoute><NotificationPage /></ProtectedRoute>} />
      </Route>

      <Route path="/view_partner_list" element={<DL />}>
        <Route index element={<ProtectedRoute><SalesAdmin_PartnerListPage /></ProtectedRoute>} />
      </Route>

      <Route path="/registration_tracking_report" element={<DL />}>
          <Route index element={<ProtectedRoute><RegistrationTrackingReportPage /></ProtectedRoute>} />
      </Route>

      <Route path="/partner_activity_report" element={<DL />}>
          <Route index element={<ProtectedRoute><PartnerActivityReportPage /></ProtectedRoute>} />
      </Route>

      <Route path="/partner_login_report" element={<DL />}>
          <Route index element={<ProtectedRoute><PartnerLoginTrackingReportPage /></ProtectedRoute>} />
      </Route>
      <Route path="/sales-admin-login-tracking" element={<DL />}>
          <Route index element={<ProtectedRoute><SalesAdminLoginTrackingReportPage /></ProtectedRoute>} />
      </Route>
      <Route path="/registration-status" element={<DL />}>
          <Route index element={<ProtectedRoute><RegistrationStatusPage /></ProtectedRoute>} />
      </Route>
      <Route path="/nps-feedback-report" element={<DL />}>
          <Route index element={<ProtectedRoute><NPSFeedbackReportPage /></ProtectedRoute>} />
      </Route>
      <Route path="/org-loc-mapping-master" element={<DL />}>
          <Route index element={<ProtectedRoute><OrgLocMappingMasterPage /></ProtectedRoute>} />
      </Route>
      <Route path="/role-user-access-mapping" element={<DL />}>
          <Route index element={<ProtectedRoute><RoleUserAccessMappingPage /></ProtectedRoute>} />
      </Route>
      </Routes>
    {/* // </Router> */}
    </>
  );
};

export default App;

// import React from "react";
// import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
// import Login from "./Pages/LoginPage";
// import Dashboard from "./Pages/DashboardPage";
// import Complaint from "./Pages/ComplaintPage";
// import User from "./Pages/UserPage";
// import Authorize from "./Pages/AuthorizePage";
// import DL from "./Layout/DashboardLayout";
// import ProtectedRoute from './Components/Authorize/ProtectedRoute';
// import NotFoundPage from './Pages/NotFoundPage';
// import './Dashboard.css';
// import './Complaint.css';
// import '../node_modules/react-datepicker/dist/react-datepicker.css';

// import PatientVisit from "./Pages/PatientVisitPage";
// import { OrganizationProvider } from './Context/OrganizationContext';

// const App = () => {
//   return (
//     <Router>
//       <Routes>
//         <Route path="/" element={<Login />} />
//         <Route path="/login" element={<Login />} />

//         <Route path="/dashboard" element={<DL><Dashboard /></DL>} />
//         <Route path="/dashboard" element={<DL />}>
//           <Route index element={<Dashboard />} />
//         </Route>

//         <Route path="/complaint" element={<DL />}>
//           <Route index element={<ProtectedRoute><Complaint /></ProtectedRoute>} />
//         </Route>

//         <Route path="/user" element={<DL />}>
//           <Route index element={<ProtectedRoute><User /></ProtectedRoute>} />
//         </Route>

//         {/* Only wrap this one in OrganizationProvider */}
//         <Route path="/patientvisit" element={
//           <OrganizationProvider>
//             <DL />
//           </OrganizationProvider>
//         }>
//           <Route index element={<ProtectedRoute><PatientVisit /></ProtectedRoute>} />
//         </Route>

//         <Route path="/authorize" element={<Authorize />} />
//         <Route path="*" element={<NotFoundPage />} />
//       </Routes>
//     </Router>
//   );
// };

// export default App;

